import { makeStyles } from "@material-ui/core";

export const stylesFiltersCard = makeStyles({
  filters: {
    paddingLeft: "0px",
    paddingBottom: "20px",
    paddingTop: "20px",
  },
});
